module.exports = __webpack_public_path__ + "static/media/german-time.a3442b8e.jpg";